// Disable browser automatic scroll restoration
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// Handle smooth scroll on page load (including cross-page navigation)
window.addEventListener('load', () => {
  let hash = window.location.hash;

  // Check sessionStorage (for cross-page navigation)
  if (!hash) {
    hash = sessionStorage.getItem('smoothScrollHash');
    if (hash) {
      sessionStorage.removeItem('smoothScrollHash');
      history.replaceState(null, '', hash);
    }
  }

  if (!hash) return;

  const target = document.querySelector(hash);
  if (!target) return;

  // Delay slightly to ensure layout is stable
  setTimeout(() => {
    const yOffset = -70; // adjust if you have fixed header
    const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }, 50);
});


// Handle click events (same page + cross-page)
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="#"]');
  if (!link) return;

  const url = new URL(link.href, window.location.origin);

  // Ignore empty or just "#"
  if (!url.hash || url.hash === '#') return;

  // Same page scroll
  if (url.pathname === window.location.pathname) {
    const target = document.querySelector(url.hash);
    if (!target) return;

    e.preventDefault();

    const yOffset = -10;
    const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });

    history.pushState(null, '', url.hash);
  } 
  else {
    // Cross-page: store hash and go without it
    e.preventDefault();
    sessionStorage.setItem('smoothScrollHash', url.hash);
    window.location.href = url.pathname + url.search;
  }
});
const BREAKPOINT = 1279;
const header = document.querySelector(".header");
const hamburger = document.querySelector(".hamburger");
const allMenuItems = document.querySelectorAll(".menu-item");
const menuButtons = document.querySelectorAll(".menu-item > a");

// Simple throttle utility
function throttle(fn, wait) {
  let inThrottle = false;
  let lastArgs;
  return function throttled(...args) {
    if (!inThrottle) {
      fn.apply(this, args);
      inThrottle = true;
      setTimeout(() => {
        inThrottle = false;
        if (lastArgs) {
          const pending = lastArgs;
          lastArgs = undefined;
          throttled.apply(this, pending);
        }
      }, wait);
    } else {
      lastArgs = args;
    }
  };
}

// Touch device detection using matchMedia (more reliable)
let isTouchDevice = false;

const checkTouchDevice = () => {
  isTouchDevice = window.matchMedia("(hover: none)").matches;
};

// Initial checks
checkTouchDevice();

// Listen for changes (orientation changes, etc.)
window.addEventListener("resize", throttle(checkTouchDevice, 150));

// Track active menu for touch devices
let activeMenu = null;
let activeMenuTimeout = null;

menuButtons.forEach((link, index) => {
  link.addEventListener("click", (e) => {
    if (isTouchDevice && window.innerWidth > BREAKPOINT) {
      e.preventDefault();
      e.stopPropagation();

      const menuItem = link.closest(".menu-item");
      const subMenu = menuItem.querySelector(".sub-menu");

      if (activeMenu === index) {
        // If already open, navigate
        window.location.href = link.href;
        if (activeMenuTimeout) clearTimeout(activeMenuTimeout);
        activeMenu = null;
      } else {
        // Open submenu instead of navigating

        // Close any other open menu
        if (activeMenu !== null) {
          const previousMenuItem = allMenuItems[activeMenu];
          const previousSubMenu = previousMenuItem.querySelector(".sub-menu");
          if (previousSubMenu) {
            previousSubMenu.style.opacity = "0";
            previousSubMenu.style.visibility = "hidden";
            //   previousSubMenu.style.minHeight = '0';
          }
        }

        // Open current menu
        if (subMenu) {
          subMenu.style.opacity = "1";
          subMenu.style.visibility = "visible";
          // subMenu.style.minHeight = '79vh';
        }

        activeMenu = index;

        // Auto-close after 5 seconds
        if (activeMenuTimeout) clearTimeout(activeMenuTimeout);
        activeMenuTimeout = setTimeout(() => {
          if (activeMenu === index) {
            if (subMenu) {
              subMenu.style.opacity = "0";
              subMenu.style.visibility = "hidden";
              subMenu.style.minHeight = "0";
            }
            activeMenu = null;
          }
        }, 5000);
      }
    }
  });
});

if (hamburger) {
  hamburger.addEventListener("click", () => {
    if (window.innerWidth > BREAKPOINT) return;
    const mainNav = hamburger.closest(".main-nav");
    const mainMenu = mainNav ? mainNav.querySelector(".main-menu") : null;
    if (!mainMenu) return;
    mainMenu.classList.toggle("active");
    hamburger.classList.toggle("active");
  });
}

// Slide helpers using height + transition
function slideUp(element) {
  element.style.height = element.scrollHeight + "px";
  // force reflow
  element.getBoundingClientRect();
  element.style.transition = "height 300ms ease";
  element.style.height = "0px";
  const clear = () => {
    element.style.transition = "";
    element.removeEventListener("transitionend", clear);
    element.style.display = "none";
  };
  element.addEventListener("transitionend", clear);
}

function slideDown(element) {
  element.style.display = "block";
  element.style.height = "0px";
  // force reflow
  element.getBoundingClientRect();
  element.style.transition = "height 300ms ease";
  element.style.height = element.scrollHeight + "px";
  const clear = () => {
    element.style.transition = "";
    element.style.height = "auto";
    element.removeEventListener("transitionend", clear);
  };
  element.addEventListener("transitionend", clear);
}

function slideToggle(element) {
  const isOpen = element.style.display !== "none" && element.offsetHeight > 0;
  if (isOpen) {
    slideUp(element);
  } else {
    slideDown(element);
  }
}

// Toggle sub-menu for each top-level menu button (mobile only)
menuButtons.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    if (window.innerWidth > BREAKPOINT) return; // only on mobile/tablet
    const li = btn.closest(".menu-item");
    const subMenu = li ? li.querySelector(":scope > .sub-menu") : null;
    if (!subMenu) return;
    e.preventDefault();
    // ensure initial state
    if (!subMenu.style.display) subMenu.style.display = "none";

    // Close any other open sub-menus within the same main menu
    const mainNav = btn.closest(".main-nav");
    const allSubMenus = mainNav
      ? mainNav.querySelectorAll(".menu-item > .sub-menu")
      : [];
    allSubMenus.forEach((el) => {
      if (el === subMenu) return;
      if (el.style.display !== "none" && el.offsetHeight > 0) {
        slideUp(el);
        const parentLi = el.closest(".menu-item");
        if (parentLi) parentLi.classList.remove("open");
      }
    });

    // Toggle current
    const willOpen =
      subMenu.style.display === "none" || subMenu.offsetHeight === 0;
    slideToggle(subMenu);
    li && li.classList.toggle("open", willOpen);
  });
});

// Ensure menu closes on resize to desktop
window.addEventListener("resize", throttle(() => {
  if (window.innerWidth > BREAKPOINT) {
    const mainNav = document.querySelector(".main-nav");
    const mainMenu = mainNav ? mainNav.querySelector(".main-menu") : null;
    if (mainMenu) mainMenu.classList.remove("active");
    if (hamburger) hamburger.classList.remove("active");
    // reset any inline styles on sub-menus
    document.querySelectorAll(".menu-item > .sub-menu").forEach((el) => {
      el.style.removeProperty("display");
      el.style.removeProperty("height");
      el.style.removeProperty("transition");
    });
    // remove open class from all menu items
    document.querySelectorAll(".menu-item.open").forEach((li) => {
      li.classList.remove("open");
    });
  }
}, 150));

let prevScrollPos = window.pageYOffset;
let isHoveringHeader = false;

// Track header hover state
header.addEventListener("mouseenter", () => {
  isHoveringHeader = true;
});

header.addEventListener("mouseleave", () => {
  isHoveringHeader = false;
});

const onScroll = throttle(() => {
  if (!header) return;
  if (window.innerWidth > BREAKPOINT) {
    if (window.scrollY > 100) {
      const currentScrollPos = window.pageYOffset;
      const headerHeight = header.offsetHeight;

      // Only hide/show header if not hovering
      if (!isHoveringHeader) {
        if (prevScrollPos > currentScrollPos) {
          // Scrolling up: show header
          header.style.transform = "translateY(0)";
        } else {
          // Scrolling down: hide header
          header.style.transform = `translateY(-${headerHeight + 12}px)`;
        }
      }

      prevScrollPos = currentScrollPos;
    }
  }
}, 100);

window.addEventListener("scroll", onScroll, { passive: true });

// On page load, mark search toggles as active after 3 seconds
window.addEventListener('load', () => {
  setTimeout(() => {
    document.querySelectorAll('.search-toggle').forEach((toggle) => {
      toggle.classList.add('active');
    });
  }, 1000);
});

// Search module toggle
const searchToggles = document.querySelectorAll('.search-toggle');
searchToggles.forEach((toggle) => {
  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Support both top-nav (inside li) and main-nav (inside .search-block)
    const block = toggle.closest('.search-block');
    const moduleFromBlock = block ? block.querySelector('.search-module') : null;
    const li = toggle.closest('li');
    const moduleFromLi = li ? li.querySelector('.search-module') : null;
    const module = moduleFromBlock || moduleFromLi;
    if (!module) return;
    if (!module.style.display) module.style.display = 'none';
    slideToggle(module);
  });
});

// Close search module if clicking outside of `search-module-inner > form`
document.addEventListener('click', (e) => {
  const insideForm = e.target.closest('.search-module-inner > form');
  if (insideForm) return;
  document.querySelectorAll('.search-module').forEach((module) => {
    if (module && module.offsetHeight > 0) {
      if (!module.style.display) module.style.display = 'none';
      slideUp(module);
    }
  });
});

// Show reset only when typing
document.querySelectorAll('.search-module input[type="text"]').forEach((input) => {
  // Set initial state
  const initModule = input.closest('.search-module');
  if (initModule) {
    initModule.classList.toggle('has-text', input.value.trim().length > 0);
  }

  // Update on input
  input.addEventListener('input', () => {
    const module = input.closest('.search-module');
    if (!module) return;
    const hasText = input.value.trim().length > 0;
    module.classList.toggle('has-text', hasText);

    // Clear any previous error when user types
    module.classList.remove('has-error');
    const error = module.querySelector('.search-error');
    if (error) {
      error.remove();
    }
  });
});

// Search reset: clear input
document.querySelectorAll('.search-module .search-reset').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const module = btn.closest('.search-module');
    const input = module ? module.querySelector('input[type="text"]') : null;
    if (input) {
      input.value = '';
      module && module.classList.remove('has-text');
    }
  });
});

// Prevent empty search submissions and show error message
document.querySelectorAll('.search-module form').forEach((form) => {
  form.addEventListener('submit', (e) => {
    const module = form.closest('.search-module');
    if (!module) return;
    const input = module.querySelector('input[type="text"]');
    if (!input) return;

    const value = input.value.trim();
    if (!value) {
      e.preventDefault();
      // Set error state
      module.classList.add('has-error');

      // Remove existing error if any
      const existingError = module.querySelector('.search-error');
      if (existingError) {
        existingError.remove();
      }

      // Create and insert error message
      const errorMsg = document.createElement('div');
      errorMsg.className = 'search-error';
      errorMsg.textContent = 'Please enter a search term.';
      errorMsg.style.color = '#d32f2f';
      errorMsg.style.fontSize = '0.875rem';
      errorMsg.style.marginTop = '4px';

      // Prefer placing error right after the input
      if (input.parentNode) {
        input.parentNode.insertBefore(errorMsg, input.nextSibling);
      } else {
        module.appendChild(errorMsg);
      }

      input.focus();
    }
  });
});

// Close search module on desktop resize
window.addEventListener('resize', throttle(() => {
  if (window.innerWidth > BREAKPOINT) {
    document.querySelectorAll('.search-module').forEach((el) => {
      el.style.removeProperty('height');
      el.style.removeProperty('transition');
      el.style.display = 'none';
      el.classList.remove('has-text');
      el.classList.remove('has-error');
      const error = el.querySelector('.search-error');
      if (error) error.remove();
    });
  }
}, 150));
